import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '@/login/login.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'LoginPage',
    component: Login
  },
  {
    path: '/home',
    name: 'homePage',
    component: () => import('@/views/home.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: 'setting',
        name: 'UserSetting',
        component: () => import('@/views/user/setting.vue')
      },
      {
        path: 'order',
        name: 'PartnerOrder',
        component: () => import('@/views/order/order.vue')
      },
      {
        path: 'order/cityManage',
        name: 'CityManage',
        component: () => import('@/views/order/cityManage.vue')
      },
      {
        path: 'order/personManage',
        name: 'PersonManage',
        component: () => import('@/views/order/personManage.vue')
      },
      {
        path: 'order/flightManage',
        name: 'FlightManage',
        component: () => import('@/views/order/flightManage.vue')
      },
      {
        path: 'user',
        name: 'AirTransport',
        component: () => import('@/views/user/user.vue')
      },
      {
        path: 'role',
        name: 'CargoDetail',
        component: () => import('@/views/role/role.vue')
      },
      {
        path: 'user/detail/:id',
        name: 'AirTransportDetail',
        component: () => import('@/views/user/userDetail.vue'),
        meta: { title: '详情' }
      }
    ]
  },
  {
    path: '/pay',
    name: 'PayPage',
    component: () => import('@/views/user/pay.vue'),
    meta: { title: '支付', requiresAuth: false }
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')

  // 已登录用户访问登录页，重定向到首页
  if (to.path === '/login' && token) {
    next('/home')
    return
  }

  // 需要登录的页面，无 token 则跳转登录页
  if (to.meta.requiresAuth && !token) {
    next('/login')
  } else {
    next()
  }
})

export default router
